import parse from 'url-parse';

import { B2B_APP_ENVS, IN_DEVELOPMENT_ENVS } from 'constants/environmentVariables';

export const isB2bEnvironment = () => B2B_APP_ENVS.includes(process.env.REACT_APP_ENV || '');

export const showInDevelopmentFeatures = () => {
  const urlData = parse(window.location.href, true);

  if (urlData.query.development === 'true') return true;
  if (urlData.query.development === 'false') return false;

  const env = process.env.REACT_APP_ENV;
  if (!env) return false;

  return IN_DEVELOPMENT_ENVS.includes(env);
};

export const isVocalGuideActivated = () => {
  return isB2bEnvironment();
};

export const showBamOnlineFeature = () => {
  return true;
};

export const isSecondMEPActivated = () => {
  return true;
};
